<mat-form-field style="width: 100%">
  <mat-date-range-input class="greco-date-range-picker-container" [rangePicker]="picker">
    <input matStartDate placeholder="Start date" [formControl]="$any(formControl.controls[0])" />
    <input matEndDate placeholder="End date" [formControl]="$any(formControl.controls[1])" />
  </mat-date-range-input>
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-date-range-picker #picker></mat-date-range-picker>
</mat-form-field>
